export default __webpack_public_path__ + "static/media/noData.cb362bda.png";